<div [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}" >

  <div style="margin-top:28px; font-size: 14px; font-weight: 500;">
    Retrofit description and associated costs
    <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
  </div>
  <form [formGroup]="formReceipts" style="margin-top: 15px;">
    <div style="margin-top:10px; ">
      <div fxLayout="row" fxLayout.lt-md="column wrap">
        <div fxFlex="55%">
          {{retrofitTypeLabel}}&nbsp;*
        </div>
        <div fxFlex="45%">
          <mat-radio-group required id="retrofittype" name="retrofittype" formControlName="retrofittype" aria-label="Select an option">
            <mat-radio-button 
              *ngFor="let retrofittype of filteredRetrofitTypeOptions" 
              style="display: block; margin-left: 0"
              [value]="retrofittype.value" 
              [checked]="retrofittype.value == application.retrofitType">
              {{ retrofittype.label }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="onCheckReceiptControlValidators('retrofittype')">
            Please choose a retrofit type
          </mat-error>
        </div>
      </div>
    </div>
    <div style="margin-top:10px; ">
      <div fxLayout="row" fxLayout.lt-md="column wrap">
        <div fxFlex="55%">
          Does your retrofit require an Engineered Solution?&nbsp;*
        </div>
        <div fxFlex="45%">
          <mat-radio-group required id="engineeredtype" name="engineeredtype" formControlName="engineeredtype" aria-label="Select an option">
            <mat-radio-button 
              *ngFor="let type of receiptEngineeredTypeOptions" 
              [value]="type.value" 
              [checked]="type.value == application.engineeredSolutionType">
              {{ type.label }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="onCheckReceiptControlValidators('engineeredtype')">
            Please select engineered solution type
          </mat-error>
        </div>
      </div>
    </div>
    <div style="margin-top:15px; margin-bottom:-5px;">
        <div fxLayout="row" fxLayout.lt-md="column wrap">
          <div fxFlex="25">
      <mat-form-field appearance="outline" style="width:150px;">
        <mat-label>Permit Cost </mat-label>
        <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0.01" required id="permitCost" name="permitCost"
          formControlName="permitCost" />
        <mat-error *ngIf="formReceipts.get('permitCost').hasError('required')">
          Permit Cost is required.
        </mat-error>
        <mat-error *ngIf="formReceipts.get('permitCost').hasError('min')">
          Permit Cost must be zero or more.
        </mat-error>
        <mat-hint>
          $0 or more
        </mat-hint>
      </mat-form-field>
    </div>
    <div fxFlex="25">
      <mat-form-field appearance="outline" style="width:150px;">
        <mat-label>Material Cost</mat-label>
        <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="materialCost" name="materialCost"
          formControlName="materialCost" />
        <mat-error *ngIf="formReceipts.get('materialCost').hasError('min')">
          Material Cost cannot be negative.
        </mat-error>
      </mat-form-field>
      </div>
      <div fxFlex="25">
      <mat-form-field appearance="outline" style="width:150px;">
        <mat-label>Labor Cost</mat-label>
        <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="laborCost" name="laborCost" formControlName="laborCost" />
        <mat-error *ngIf="formReceipts.get('laborCost').hasError('min')">
          Labor Cost cannot be negative.
        </mat-error>
      </mat-form-field></div>
      <div fxFlex="25">
      <mat-form-field appearance="outline" style="width:150px;">
        <mat-label>Overhead & Profit</mat-label>
        <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="0" id="overheadProfitCost" name="overheadProfitCost"
          formControlName="overheadProfitCost" />
        <mat-error *ngIf="formReceipts.get('overheadProfitCost').hasError('min')">
          Overhead & Profit cannot be negative.
        </mat-error>
      </mat-form-field>
      </div>
      </div>
    </div>



  <div style="margin-top: 12px; ">

    <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
  </div>

    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap.lt-md="3px" >

 <div fxFlex="25" style="margin-top: 15px; ">
  <label for="totalamount"><strong>TOTAL COSTS</strong></label>
 </div>
 <div fxFlex="25"></div>
 <div fxFlex="25"></div>

      <div fxFlex="25" style="margin-top: 15px; ">
        <div  style="width:150px;height:30px;text-align:right"><strong>{{ totalAmount() | currency  }}</strong></div>
    
      </div>
    </div>

  <div style="margin-bottom: 12px; ">
      <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
    </div>
    <div>
      <button mat-raised-button color="primary" type="submit" (click)="onClickSaveReceiptsInfo()"
        [disabled]="disableSaveButton && (formReceipts.pristine || formReceipts.invalid)">
        SAVE
      </button>
    </div>
    <div *ngIf="autoSaveIndicator" style="margin-top: 12px;">
      <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
    </div>
  </form>
</div>
